import React, { useState } from "react";
import { Box } from "@mui/system";
import { Typography, Button, Grid } from "@mui/material";
import TableLayout from "../components/table";
import SearchSelect from "../components/searchAndSelect";
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { bankDetailsClicked } from '../store/gloabalState'
import { getBankMainDetails, getBankUsers } from '../services/httpCalls'

export default function VendorsView() {
    const [bankDetails, setBankDetails] = useRecoilState(bankDetailsClicked);
    const [mainBankDetails, setMainBankDetails] = useState()
    const [userList, setUserList] = useState()
    let navigate = useNavigate();

    const selectSearchData = (e) => {
        setBankDetails(e);
    };

    const getBankDetails = async () => {
        await getBankMainDetails(bankDetails.id)
            .then((res) => {
                setMainBankDetails(res);
            })
        await getBankUsers(bankDetails.id)
            .then((res) => {
                setUserList(res)
            })
            
    }
    return (
        <Box sx={{ marginBottom: "1rem" }}>
            <Box sx={{ padding: ".5rem", display: "flex" }}>
                <SearchSelect
                    selectSearchData={selectSearchData}
                    label={"Select Bank"}
                    name={"bankname"}
                />
                <Button
                    onClick={getBankDetails}
                    variant="contained"
                    sx={{ margin: ".5rem 1rem" }}
                >
                    Edit Bank
                </Button>
            </Box>
            {mainBankDetails?.name && (
                <Box sx={{ padding: "1rem" }}>
                    <Typography
                        variant="h5"
                        sx={{ paddingBottom: "1rem", fontWeight: 400 }}
                    >
                        Details of <b>{mainBankDetails?.name}</b>
                        <Button
                            variant="outlined"
                            onClick={() => navigate(`/editbank/${mainBankDetails?.id}`)}
                            sx={{ float: "right" }}
                        >
                            Edit
                        </Button>
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Box
                                sx={{
                                    padding: ".5rem 0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                    Name :{" "}
                                </Typography>
                                <Typography
                                    variant="p"
                                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                                >
                                    {mainBankDetails?.name ? mainBankDetails?.name : "-"}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box
                                sx={{
                                    padding: ".5rem 0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                    Start Hour:
                                </Typography>
                                <Typography
                                    variant="p"
                                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                                >
                                    {mainBankDetails?.startHour ? mainBankDetails?.startHour + " hrs" : "-"}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box
                                sx={{
                                    padding: ".5rem 0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                    Stop Hour :
                                </Typography>
                                <Typography
                                    variant="p"
                                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                                >
                                    {mainBankDetails?.stopHour ? mainBankDetails?.stopHour + " hrs" : "-"}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box
                                sx={{
                                    padding: ".5rem 0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                    Ops User Wait Hour :
                                </Typography>
                                <Typography
                                    variant="p"
                                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                                >
                                    {mainBankDetails?.opsUserWaitHour ? mainBankDetails?.opsUserWaitHour + " hrs" : "-"}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box
                                sx={{
                                    padding: ".5rem 0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                    Mid Office User Wait Hour :
                                </Typography>
                                <Typography
                                    variant="p"
                                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                                >
                                    {mainBankDetails?.midOfficeUserWaitHour ? mainBankDetails?.midOfficeUserWaitHour + " hrs" : "-"}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box
                                sx={{
                                    padding: ".5rem 0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                    Backend User Wait Hour :
                                </Typography>
                                <Typography
                                    variant="p"
                                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                                >
                                    {mainBankDetails?.backendUserWaitHour
                                        ? mainBankDetails?.backendUserWaitHour + " hrs"
                                        : "-"}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            )}
            {userList && (
                <Box sx={{ padding: "1rem", marginBottom: "4rem" }}>
                    <Typography
                        variant="h6"
                        sx={{ paddingBottom: "1rem", fontWeight: 400 }}
                    >
                        Users of <b>{mainBankDetails?.name}</b>
                    </Typography>
                    <TableLayout
                        transactions={userList}
                        type={"bankUsers"}
                    />
                </Box>
            )}
        </Box>
    )
}